import React from "react";
import { CollectionNewSearchBar } from "./CollectionSearchBar/CollectionNewSearchBar";
import { CollectionNewSearchPageTranslations } from "../CollectionNewSearchPageTranslations.csharp";
import { CheckBox } from "../../Ecommerce/Shared/Checkbox/Checkbox";
import { SearchParams } from "../CollectionNewSearchPage";
import { CollectionFilter } from "./FilterDrawer/CollectionFilter";
import { MotifRelationship } from "../MotifRelationship";
import { CollectionNewSearchProps } from "../CollectionNewSearchProps.csharp";
import { CustomSelect } from "../../../ReactComponents/cusomSelect/CustomSelect";

export interface ICollectionNewSearchProps {
    query: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    searchParams: SearchParams;
    setSearchParams: React.Dispatch<React.SetStateAction<SearchParams>>;
    handleSearch: (word?: string) => void;
    props: CollectionNewSearchProps;
    setMinYear: React.Dispatch<React.SetStateAction<number>>;
    setMaxYear: React.Dispatch<React.SetStateAction<number>>;
    minYear: number;
    maxYear: number;
    activeFilters: number;
    filterAllMotifs: MotifRelationship | null;
    filterAllThemes: MotifRelationship | null;
    filterAllExhibitions?: MotifRelationship | null;
    motifFacetCounts: { [key: string]: number };
    themeFacetCounts: { [key: string]: number };
    exhibitionFacetCounts?: { [key: string]: number };
    totalCount: number;
    filterIsOpen: boolean;
    setFilterIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CollectionNewSearch: React.FC<ICollectionNewSearchProps> = ({
    query,
    onChange,
    searchParams,
    setSearchParams,
    handleSearch,
    props,
    setMinYear,
    setMaxYear,
    minYear,
    maxYear,
    activeFilters,
    filterAllMotifs,
    filterAllThemes,
    filterAllExhibitions,
    motifFacetCounts,
    themeFacetCounts,
    exhibitionFacetCounts,
    totalCount,
    filterIsOpen,
    setFilterIsOpen,
}) => {
    const sortingOptions = [
        { value: "default", label: props.translations.sortingRelevant },
        { value: "invNo", label: props.translations.sortingInventoryNumber },
        { value: "descDate", label: props.translations.sortingDescending },
        { value: "ascDate", label: props.translations.sortingAscending },
    ];

    return (
        <div className="Search__container">
            <CollectionNewSearchBar
                query={query}
                onChange={onChange}
                handleSearch={handleSearch}
                exampleSearchTerms={props.exampleSearchTerms}
                translations={props.translations}
                setSearchParams={setSearchParams}
                searchParams={searchParams}
            />

            <div className="Search__checkboxes-container">
                <CheckBox
                    label={props.museumCollectionLabel}
                    isChecked={searchParams.showMainCollection}
                    setIsChecked={(value: boolean) => {
                        setSearchParams(prev => ({
                            ...prev,
                            showMainCollection: value,
                            showAll: !(value || prev.showDisplayed),
                        }));
                    }}
                />
                <CheckBox
                    label={props.onDisplayLabel}
                    isChecked={searchParams.showDisplayed}
                    setIsChecked={(value: boolean) => {
                        setSearchParams(prev => ({
                            ...prev,
                            showDisplayed: value,
                            showAll: !(prev.showMainCollection || value),
                        }));
                    }}
                />
            </div>

            <div className="Search__filter-and-sorting-container">
                <div className="Search__sorting-options Select__Container">
                    <label className="Input__Label--hidden" htmlFor="collection-sorting-options">
                        {props.translations.sortingLabel}
                    </label>
                    <CustomSelect
                        prefix={props.translations.sortingPrefix}
                        options={sortingOptions}
                        value={searchParams.sortingOption}
                        onChange={(val) =>
                            setSearchParams(prev => ({ ...prev, sortingOption: val }))
                        }
                        placeholder={props.translations.sortingLabel}
                    />
                </div>

                <CollectionFilter
                    translations={props.translations}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    setMinYear={setMinYear}
                    setMaxYear={setMaxYear}
                    minYear={minYear}
                    maxYear={maxYear}
                    activeFilters={activeFilters}
                    filterAllMotifs={filterAllMotifs}
                    filterAllThemes={filterAllThemes}
                    filterAllExhibitions={filterAllExhibitions}
                    motifFacetCounts={motifFacetCounts}
                    themeFacetCounts={themeFacetCounts}
                    exhibitionFacetCounts={exhibitionFacetCounts}
                    totalCount={totalCount}
                    filterIsOpen={filterIsOpen}
                    setFilterIsOpen={setFilterIsOpen}
                />
            </div>
        </div>
    );
};
